<section id="roadmap" class="roadmap">
    <div class="container max-container position-relative">
        <h2 class=" heading m-0 mb-3 pb-4 text-black text-start text-md-center position-relative" translate>roadmap_title <img src="/assets/images/svg-icons/roadmap-title-icon.svg" class="img-title" alt=""> </h2>
        <!-- <p class="mx-auto px-0 mb-5 pb-4 font-20 text-black fw-regular px-md-4 text-start text-md-center" translate>roadmap_desc</p> -->
        <div class="row">
            <div class="col-md-6 col-lg-3 mb-4" *ngFor="let item of items">
                <div class="roadmap-box text-center">
                    <h3 class="text-primary mb-3" translate>{{ item.title }}</h3>
                    <!-- <p class="font-16" translate>{{ item.subtitle }}</p> -->
                    <p class="text-primary font-14 roadmap-desc mb-0" translate>{{ item.description }}</p>
                </div>
            </div>

        </div>
    </div>
</section>
